import { FunctionComponent, useCallback } from 'react'
import { useConversationTurn } from '../../../hooks/utils/statsAssistant'
import { ChatComposer } from '../ChatComposer'
import { ChatThread } from '../ChatThread'
import { StatsConversationProps } from './StatsConversation.model'

export const StatsConversation: FunctionComponent<StatsConversationProps> = ({
  chat,
  compact = false,
  onChartExpand,
}) => {
  const { isProcessing, progressText, error } = useConversationTurn(chat.conversationUlid)
  const editingMessage = chat.messages.find(({ ulid }) => ulid === chat.editingMessageUlid)
  const draftKey = `${chat.conversationUlid ?? 'new'}-${chat.editingMessageUlid ?? 'none'}`
  const { setDraft } = chat
  const handleDraftChange = useCallback(
    (value: string) => setDraft(draftKey, value),
    [draftKey, setDraft],
  )

  return (
    <>
      <ChatThread
        conversationUlid={chat.conversationUlid}
        scrollSnapshotRef={chat.threadScrollRef}
        messages={chat.messages}
        isLoading={chat.isConversationLoading}
        isProcessing={isProcessing}
        progressText={progressText}
        turnError={error}
        agentProfiles={chat.agentProfiles}
        agentProfile={chat.agentProfile}
        onAgentProfileChange={chat.setAgentProfile}
        compactChart={compact}
        onSuggestionSelect={chat.sendUserMessage}
        onChartExpand={onChartExpand}
        onStop={chat.cancelTurn}
        onRetryLastTurn={chat.retryLastTurn}
        onRetryTurnError={chat.retryTurnError}
        onEditUserMessage={chat.startEditUserMessage}
      />
      <ChatComposer
        key={draftKey}
        disabled={chat.isConversationLoading}
        isProcessing={isProcessing}
        isEditing={chat.editingMessageUlid !== null}
        initialValue={
          chat.getDraft(draftKey) ??
          (editingMessage?.type === 'text' ? editingMessage.content.text : '')
        }
        onDraftChange={handleDraftChange}
        onSend={chat.sendUserMessage}
        onStop={chat.cancelTurn}
        onCancelEdit={chat.cancelEdit}
      />
    </>
  )
}
